import { LevelSpecSchema, type LevelSpec } from './schema';

export function parseLevel(input: unknown): LevelSpec {
  const level = LevelSpecSchema.parse(input);
  validateRefs(level);
  validateGrid(level);
  validateOptimalItems(level);
  return level;
}

function validateOptimalItems(level: LevelSpec): void {
  const total = level.mirrors.available + level.prisms.available;
  if (level.optimalItems > total) {
    throw new Error(
      `optimalItems (${level.optimalItems}) exceeds the total devices available ` +
        `(${level.mirrors.available} mirrors + ${level.prisms.available} prisms = ${total})`,
    );
  }
}

function validateRefs(level: LevelSpec): void {
  const switchIds = new Set(level.switches.map((s) => s.id));
  for (const id of level.exit.requires) {
    if (!switchIds.has(id)) {
      throw new Error(`exit requires unknown switch id: ${id}`);
    }
  }
}

function validateGrid(level: LevelSpec): void {
  const { width, height } = level.grid;
  const inBounds = (p: { x: number; y: number }, what: string): void => {
    if (p.x < 0 || p.x >= width || p.y < 0 || p.y >= height) {
      throw new Error(`${what} (${p.x},${p.y}) is outside grid ${width}×${height}`);
    }
  };
  for (const s of level.lightSources) inBounds(s.pos, 'light source');
  for (const slot of level.slots) inBounds(slot, 'slot');
  for (const s of level.switches) inBounds(s.pos, 'switch');
  inBounds(level.exit.pos, 'exit');
  for (const w of level.walls ?? []) inBounds(w, 'wall');
}
